<template>
    <v-dialog
        v-model="dialog"
        max-width="1000"
    >
        <v-card>
            <v-text-field
                class="url-hidden"
                v-model="hidden.url"
                ref="url"
                single-line
            ></v-text-field>
            <div class="close" @click="dialog = !dialog">
                <i class="material-icons">close</i>
            </div>
            <div class="info-block">
                Shared Events
            </div>
            <v-container fluid class="table-container">
                <v-layout row>
                    <v-flex md12>
                        <v-data-table
                            :headers="sharedEventsTable.headers"
                            :items="sharedEventsTable.items"
                            hide-actions
                            :pagination.sync="sharedEventsTable.pagination"
                            :loading="sharedEventsTable.loading"
                            :page.sync="sharedEventsTablePages"
                            :total-items="sharedEventsTable.totalItems"
                        >
                            <template v-slot:items="props">
                                <tr class="package-row">
                                    <td>{{ props.item.name }}</td>
                                    <td>{{ dateFormat(props.item.expirationDate) }}</td>
                                    <td>
                                        <router-link :to="`/shared-event/${props.item.uri}`" target="_blank">
                                            Link to share
                                        </router-link>
                                    </td>
                                    <td>
                                        <sp-button @click.native="copyURL(props.item.uri)" design-type="table-button" icon="link"></sp-button>
                                    </td>
                                    <td v-if="hasAllRoles(['EventShareUpdate'])">
                                        <sp-button @click.native="editSharedEvent(props.item)" design-type="table-button" icon="edit"></sp-button>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-container>

            <div v-if="isUpdateFormShow && hasAllRoles(['EventShareUpdate'])">
                <div class="info-block">
                    Update shared event
                </div>

                <v-form
                    ref="updateForm"
                    v-model="valid"
                    lazy-validation
                >
                    <v-container fluid>
                        <v-layout row>
                            <v-flex md2>
                                <div class="label">Name</div>
                            </v-flex>
                            <v-flex md10>
                                <v-text-field
                                    label="Package name"
                                    v-model="updateForm.name"
                                    :rules="rules.name"
                                    required
                                    outline
                                    single-line
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex md2>
                                <div class="label">Description</div>
                            </v-flex>
                            <v-flex md10>
                                <v-text-field
                                    label="Package description"
                                    v-model="updateForm.description"
                                    required
                                    outline
                                    single-line
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex md2>
                                <div class="label">Expiration time</div>
                            </v-flex>
                            <v-flex md10>
                                <v-menu
                                    ref="isDatePickerShow"
                                    v-model="isDatePickerShow"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="updateForm.dateString"
                                            label="Picker in menu"
                                            prepend-inner-icon="event"
                                            readonly
                                            v-on="on"
                                            outline
                                            single-line
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="updateForm.dateString" :min="minDate" no-title scrollable>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex md12 class="text-xs-right">
                                <sp-button @click.native="updateSharedEvent" sp-class="no-padding-right" small-icon icon="arrow-left" text="Update shared event"></sp-button>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import SpButton from '@/components/forms/Button'
import moment from 'moment'
import toast from '@/plugins/izitoast'
import { formatDate } from '@/helpers/Utils'
import { DeviceEventSharedApi } from '@/api'

const deviceEventSharedApi = new DeviceEventSharedApi()

export default {
    name: 'ShareEventList',
    mounted () {
        this.updateForm.dateString = moment().add(1, 'day').format('YYYY-MM-DD')
        this.minDate = moment().format('YYYY-MM-DD HH:mm')
        this.getSharedEvents()
    },
    components: {
        SpButton
    },
    data () {
        return {
            dialog: false,
            valid: false,
            updateFormValid: false,
            isDatePickerShow: false,
            minDate: null,
            isUpdateFormShow: false,
            loading: false,
            sharedEventList: [],
            updateForm: {
                name: '',
                description: '',
                dateString: ''
            },
            hidden: {
                url: ''
            },
            sharedEventsTable: {
                totalItems: 0,
                page: 1,
                pagination: {
                    rowsPerPage: 1,
                    maxButtons: 5,
                    totalItems: 0,
                    page: 1
                },
                items: [],
                headers: [
                    {
                        text: 'Name',
                        value: 'name',
                        width: !this.hasAllRoles(['EventShareUpdate']) ? '' : '230px',
                        sortable: false
                    },
                    {
                        text: 'Expiration date',
                        value: 'expirationDate',
                        width: !this.hasAllRoles(['EventShareUpdate']) ? '' : '230px',
                        sortable: false
                    },
                    {
                        text: 'URL',
                        value: 'url',
                        sortable: false
                    },
                    {
                        text: 'Copy link',
                        sortable: false
                    },
                    {
                        text: 'Edit',
                        sortable: false,
                        class: !this.hasAllRoles(['EventShareUpdate']) ? 'd-none' : ''
                    }
                ]
            },
            rules: {
                name: [
                    v => (v.length && 4 <= v.length && 50 >= v.length) || 'Name must be at least 4 and less than 50 characters'
                ]
            }
        }
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        hardwareId: {
            type: String,
            required: false,
            default: null
        }
    },
    computed: {
        result: {
            get () {
                return this.value
            },
            set (value) {
                this.$emit('input', this.dialog)
            }
        },
        sharedEventsTablePages () {
            if (null == this.sharedEventsTable.pagination.rowsPerPage || null == this.sharedEventsTable.pagination.totalItems) return 0

            return Math.ceil(this.sharedEventsTable.pagination.totalItems / this.sharedEventsTable.pagination.rowsPerPage)
        },
    },
    watch: {
        value: {
            handler () {
                this.dialog = this.value
            }
        },
        dialog (val) {
            this.$emit('input', val)
            this.getSharedEvents()
        }
    },
    methods: {
        async getSharedEvents () {
            const response = await deviceEventSharedApi.getDeviceEventsShared({
                hardwareId: this.hardwareId
            })

            if (!response.isSuccess) {
                return
            }

            this.sharedEventsTable.items = response.payload.items
            this.sharedEventsTable.totalItems = response.payload.totalResults
            this.sharedEventsTable.pagination.totalItems = response.payload.totalResults
        },
        dateFormat (date) {
            return formatDate(date)
        },
        editSharedEvent (event) {
            this.updateForm = {
                id: event.id,
                name: event.name,
                description: event.description,
                dateString: moment(event.expirationDate).format('YYYY-MM-DD')
            }
            this.isUpdateFormShow = true
        },
        async updateSharedEvent () {
            this.valid = this.$refs.updateForm.validate()
            if (!this.valid) {
                return false
            }

            const response = await deviceEventSharedApi.updateDeviceEventShare({
                id: this.updateForm.id,
                name: this.updateForm.name,
                description: this.updateForm.description,
                expirationDate: moment(this.updateForm.dateString).format('YYYY-MM-DDTHH:mm:ss').toString() + 'Z'
            })

            if (!response.isSuccess) {
                return
            }

            await this.getSharedEvents()

            this.isUpdateFormShow = false
            toast.success('Shared Event updated successfully')
        },
        async copyURL (uri) {
            this.hidden.url = await `${window.location.origin}/shared-event/${uri}`
            const urlToCopy = await this.$refs.url.$el.querySelector('input')
            urlToCopy.select()
            document.execCommand('copy')
            toast.success('Link coppied')
        }
    }
}
</script>

<style scoped lang="scss">
.info-block {
    margin-bottom: 20px;

    &.info-success {
        border-color: $success;
    }
}

.table-container {
    padding: 24px 16px;
}

.label {
    position: relative;
    top: 14px;
}

.url-hidden {
    position: absolute;
    top: 40px;
    left: -9999px;
}
.error--text {
    font-size: 12px;
}

.package-input {
    padding: 5px 0;
}

.package-buttons {
    margin-top: 10px;
}

.close {
    position: absolute;
    top: 18px;
    right: 20px;
    cursor: pointer;

    &:hover {
        opacity: 0.7;
    }
}
</style>
